module.exports = __webpack_public_path__ + "img/handwithflower.b4184a9b.svg";